/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  let refreshing = false
  let pendingVisibilityHandler: (() => void) | null = null

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return

    if (document.visibilityState !== 'visible') {
      if (pendingVisibilityHandler) {
        document.removeEventListener('visibilitychange', pendingVisibilityHandler)
      }

      pendingVisibilityHandler = () => {
        if (document.visibilityState === 'visible' && !refreshing) {
          refreshing = true
          if (pendingVisibilityHandler) {
            document.removeEventListener('visibilitychange', pendingVisibilityHandler)
            pendingVisibilityHandler = null
          }
          window.location.reload()
        }
      }
      document.addEventListener('visibilitychange', pendingVisibilityHandler)
      return
    }

    refreshing = true
    window.location.reload()
  })

  let lastUpdateCheck = 0
  const UPDATE_CHECK_INTERVAL = 30000
  const POLLING_INTERVAL = 300000

  let visibilityHandler: (() => void) | null = null
  let onlineHandler: (() => void) | null = null
  let focusHandler: (() => void) | null = null

  const checkForUpdates = (registration: ServiceWorkerRegistration) => {
    const now = Date.now()
    if (now - lastUpdateCheck < UPDATE_CHECK_INTERVAL) {
      return
    }
    if (!navigator.onLine) {
      return
    }

    lastUpdateCheck = now
    registration.update().catch((error) => {
      console.error('Service worker update check failed:', error)
    })
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    registered (registration) {
      if (visibilityHandler) {
        document.removeEventListener('visibilitychange', visibilityHandler)
      }
      if (onlineHandler) {
        window.removeEventListener('online', onlineHandler)
      }
      if (focusHandler) {
        window.removeEventListener('focus', focusHandler)
      }

      if (navigator.serviceWorker.controller && document.visibilityState === 'visible' && navigator.onLine) {
        registration.update().catch((error) => {
          console.error('Initial service worker update check failed:', error)
        })
      }

      visibilityHandler = () => {
        if (document.visibilityState === 'visible') {
          checkForUpdates(registration)
        }
      }
      onlineHandler = () => checkForUpdates(registration)
      focusHandler = () => checkForUpdates(registration)

      document.addEventListener('visibilitychange', visibilityHandler)
      window.addEventListener('online', onlineHandler)
      window.addEventListener('focus', focusHandler)

      setInterval(() => {
        if (document.visibilityState === 'visible' && navigator.onLine) {
          registration.update().catch((error) => {
            console.error('Periodic service worker update check failed:', error)
          })
        }
      }, POLLING_INTERVAL)
    },

    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
